module.exports = __webpack_public_path__ + "images/Balance-3a73bb.png";